import { render, staticRenderFns } from "./agingTimeByCategory.vue?vue&type=template&id=03d1ad93&scoped=true"
import script from "./agingTimeByCategory.vue?vue&type=script&lang=js"
export * from "./agingTimeByCategory.vue?vue&type=script&lang=js"
import style0 from "./agingTimeByCategory.vue?vue&type=style&index=0&id=03d1ad93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d1ad93",
  null
  
)

export default component.exports